function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.978 4.419c0-.665.456-1.205 1.022-1.205.564 0 1.023.54 1.023 1.205 0 .666-.459 1.206-1.023 1.206-.566 0-1.022-.54-1.022-1.206zM3.682 19.286l1.636-4.822 2.045-4.018-.407-2.41L5.318 2.41h-.41v-.804h8.183v.804h-.409l-1.638 5.625-.409 2.41 2.045 4.018 1.64 4.822h-.816l-2.048-4.018L9 12.858l-2.454 2.41-2.05 4.018h-.814zM6.137 2.41L8.18 6.429h1.638l2.044-4.018H6.137zM0 3.214h1.637V.804H0v2.41zm2.456.804H4.09V0H2.454v4.018h.002zm13.906-.804H18V.804h-1.637v2.41h-.001zm-2.454.804h1.636V0h-1.636v4.018z",
  fill: "#969696",
  fillRule: "evenodd"
});

var SvgStrain = function SvgStrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fillOpacity: 0.7,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/strain.f098efe4.svg";
export { ForwardRef as ReactComponent };